// extracted by mini-css-extract-plugin
module.exports = {"pageRailLeft":"PageRail_pageRailLeft__GsdTm","pageRailRight":"PageRail_pageRailRight__PBd14"};